/**
 * 审批管理
 **/

export default [
  {
    path: 'appr/manage',
    name: '审批管理',
    component: () => import (`@/views/appr/index.vue`),
  },
  {
    path: 'appr/add',
    name: '设置流程',
    component: () => import (`@/views/appr/add.vue`),
  },
  {
    path: 'appr/setting',
    name: '设置流程',
    component: () => import (`@/views/appr/workflow/setting.vue`),
  }
]
